import React, { useState } from "react";
import "./Project.css";
import Card from "../UI/Card";
import Projects from "../../Data/Project-list";

const Project = () => {
   const [items, setItems] = useState(Projects);
  // const [limitElement, setLimitElement] = useState(3);

  // const slice = items.slice(0, limitElement);

  // const loadMore = () => {
  //   setLimitElement(limitElement + limitElement);
  // };
  // const hideMore = () => {
  //   setLimitElement(limitElement - 3);
  // };

  return (
    <div className="sec " id="Projects">
      <div className="heading">
        <h1>Projects</h1>
      </div>

      <div className="container ">
        <div className="row ">
          {items.map((item) => {
            const { id, image, title, codebase, technology } = item;
            return (
              <div
                className="col-12 col-sm-12 col-md-4  col-lg-4  parent"
                key={id}
              >
                <li className="child_pro ">
                  <Card
                    image={image}
                    title={title}
                    codebase={codebase}
                    technology={technology}
                  />
                </li>
              </div>
            );
          })}
        </div>
      </div>

      {/* <div className="loadButtonDiv">
      <button onClick={loadMore}>More</button>
      
     {limitElement >3 &&
        <button onClick={hideMore}>Hide</button>}
      </div> */}
    </div>
  );
};

export default Project;
